import useUserStore from "@/state/user/useUserStore";
import React, { useEffect } from "react";
import {
  ArrowBigLeft,
  Disc3,
  Eye,
  GraduationCap,
  Shirt,
  Smile,
} from "lucide-react";
import Footer from "@/components/ui/footer";
import { Asset } from "@/types/types";
import { PostPage } from "@/components/formats/post-page";
import MemeTemplate from "@/components/ui/meme-template";
import UploadMeme from "@/components/ui/upload-meme";
import {
  MemeGrid,
  RouteWrapper,
  TabLogo,
  TitleShadowBullas,
  UploadImageContainer,
} from "@/components/styles";
import { BannerPage } from "@/components/formats/banner-page";
import Image from "@/components/ui/image";
import { ScrollView, Window } from "react95";
import Link from "next/link";
import { WindowContent, WindowHeader } from "react95";

export const BullasPage = () => {
  const [tabs, setRestrictedFonts, imageFormat, assetsCount] = useUserStore(
    (state) => [
      state.tabs,
      state.setRestrictedFonts,
      state.imageFormat,
      state.assetsCount,
    ]
  );

  const HeadAssets = Array.from(
    { length: assetsCount?.base },
    (_, i) => `/Mememaker/base/base${i + 1}.png`
  );

  const ClothingAssets = Array.from(
    { length: assetsCount?.clothing },
    (_, i) => `/Mememaker/clothing/clothing${i + 1}.png`
  );

  const FaceAssets = Array.from(
    { length: assetsCount?.headgear },
    (_, i) => `/Mememaker/headgear/headgear${i + 1}.png`
  );

  const EyeAssets = Array.from(
    { length: assetsCount?.face },
    (_, i) => `/Mememaker/face/face${i + 1}.png`
  );

  const MiscAssets = Array.from(
    { length: assetsCount?.misc },
    (_, i) => `/Mememaker/misc/misc${i + 1}.png`
  ).reverse();

  const allAssets: Asset[] = [
    { assets: HeadAssets, icon: <Smile /> },
    { assets: ClothingAssets, icon: <Shirt /> },
    { assets: FaceAssets, icon: <GraduationCap /> },
    { assets: EyeAssets, icon: <Eye /> },
    { assets: MiscAssets, icon: <Disc3 /> },
  ];

  useEffect(() => {
    setRestrictedFonts([{ value: "title11", label: "Bullas" }]);
  }, []);

  const tweetText = `I Love The Smell Of MOOLA In The Morning. #WankDatBearGame`;

  return (
    <>
      <RouteWrapper>
        <Window
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            fontFamily: "var(--font-cabin-condensed)",
            overflow: "hidden",
          }}
        >
          <strong>
            <WindowHeader
              className="window-title"
              style={{ background: "#623a00" }}
            >
              <div
                style={{
                  gap: 8,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    position: "relative",
                  }}
                >
                  <Image
                    src={"/Mememaker/beraflip/beraflip.png"}
                    alt={"beraflip"}
                    fill
                    style={{
                      objectFit: "contain",
                    }}
                  />
                </div>
                <span style={{ fontWeight: 500 }}>Beraflip</span>
              </div>
            </WindowHeader>
          </strong>
          <WindowContent
            style={{
              padding: 8,
              boxSizing: "border-box",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ScrollView
              style={{
                width: "100%",
                flexGrow: "1",
                background: "#ddd",
                position: "relative",
                overflow: "hidden",
                display: "flex",
                maxHeight: "calc(100vh - 62px)",
              }}
            >
              {(() => {
                switch (imageFormat) {
                  case "banner":
                    return (
                      <BannerPage
                        color="#5a9d6e"
                        assets={allAssets}
                        customFont="bullas"
                        twitter="TheBullas_"
                        tweetText={tweetText}
                        websiteLink="https://www.bullas.xyz/"
                      />
                    );
                  case "post":
                    return (
                      <PostPage
                        color="#5a9d6e"
                        assets={allAssets}
                        customFont="bullas"
                        twitter="TheBullas_"
                        tweetText={tweetText}
                        websiteLink="https://www.bullas.xyz/"
                      />
                    );
                  default:
                    return (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "flex",
                            flexDirection: "column",
                            boxSizing: "border-box",
                            padding: "36px",
                            gap: "12px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginBottom: "16px",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "start",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <TitleShadowBullas
                                style={{ margin: 0, marginBottom: "4px" }}
                              >
                                Bullas
                              </TitleShadowBullas>
                              <p
                                style={{
                                  margin: 0,
                                  fontFamily: "var(--font-cabin-condensed)",
                                }}
                              >
                                Select a preset meme template to start creating
                                your meme.
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              <Link
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  fontFamily: "var(--font-cabin-condensed)",
                                  whiteSpace: "nowrap",
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="/"
                              >
                                <UploadImageContainer
                                  whileHover={{
                                    scale: 1.02,
                                    transition: {
                                      duration: 0.15,
                                      ease: "linear",
                                    },
                                  }}
                                  whileTap={{ scale: 0.99 }}
                                >
                                  <ArrowBigLeft size={20} />
                                  Back
                                </UploadImageContainer>
                              </Link>
                            </div>
                          </div>
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              flexDirection: "row",
                              gap: "16px",
                            }}
                          >
                            <MemeGrid>
                              <MemeTemplate src="/Mememaker/bullas/background/background1.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background2.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background3.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background4.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background5.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background6.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background7.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background8.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background9.png" />
                              <MemeTemplate src="/Mememaker/bullas/background/background10.png" />
                            </MemeGrid>
                          </div>
                        </div>
                        <Footer />
                      </div>
                    );
                }
              })()}
            </ScrollView>
          </WindowContent>
        </Window>
      </RouteWrapper>
    </>
  );
};
